import { useStore } from 'react-redux';

import { isB2B, isB2C } from '@/domains/core/settings/utils';
import type { SpartacuxState } from '@/domains/core/shell/applicationState/root.state';
import type { Product } from '@/domains/productDiscovery/algolia/interfaces/product';

export const useAlgoliaCTRTrackingEvent = (): {
  sendAlgoliaCTRTrackingEvent: (product: Product, position: number) => void;
} => {
  const store = useStore<SpartacuxState>();
  /*TODO: this was a call to 'useFeatureFlags' replaced with the value of the flag/abtest. Consider removing this call when you modify the file.*/
  const [
    isB2BAlgoliaSearchInsightsTrackingEnabled,
    isB2CAlgoliaSearchInsightsTrackingEnabled,
  ] = [true, true];

  const sendAlgoliaCTRTrackingEvent = async (
    product: Product,
    position: number,
  ) => {
    if (
      (isB2B() && isB2BAlgoliaSearchInsightsTrackingEnabled) ||
      (isB2C() && isB2CAlgoliaSearchInsightsTrackingEnabled)
    ) {
      const { sendTracking } = await import('./tracking');
      const state = store.getState();
      sendTracking(state, product, position);
    }
  };

  return {
    sendAlgoliaCTRTrackingEvent,
  };
};
